import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
    // Extracts the current pathname from the route
    const { pathname } = useLocation();

    // Automatically triggers whenever the pathname changes
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    // This component doesn't render any UI
    return null;
};

export default ScrollToTop;